<template>
  <div
    class="tw-relative tw-z-10 tw-flex tw-cursor-pointer tw-items-center tw-gap-2.5"
  >
    <c-avatar
      size="24px"
      font-size="10px"
      color="blue"
      :name="user?.formattedName ?? ''"
      :src="user?.profileImage"
    />

    <div class="tw-font-medium">{{ user?.firstName }}</div>

    <q-icon
      size="12px"
      name="fa-solid fa-chevron-down tw-transition-all"
      :class="{
        'tw-rotate-180': isOpen,
      }"
    />

    <c-menu v-model="isOpen" class="tw-p-2" :offset="[0, 16]">
      <menu-link
        v-for="(item, key) in links"
        :key="key"
        class="font-weight-normal"
        :item
      />
    </c-menu>
  </div>
</template>

<script setup lang="ts">
import { toClassicIcon, webmasterIcon } from "common/defaultIcons";
import MenuLink from "components/layout/MenuLink.vue";
import { useAuthStore } from "core/auth/auth.store";
import { storeToRefs } from "pinia";
import { useAuthorizationStore } from "store/modules/authorizationStore.js";
import { useMenuStore } from "store/modules/menuStore.js";
import { computed, onMounted, ref } from "vue";

// Auth store
const authStore = useAuthStore();
const { loadCurrentUser } = authStore;
const { user } = storeToRefs(authStore);

// menuStore
// TODO: The functions below should be placed in the auth store
const menuStore = useMenuStore();
const { logout, logoutMenuItem } = menuStore;
const { profileItems } = storeToRefs(menuStore);

// Authorization Store
const authorizationStore = useAuthorizationStore();
const { returnAsWebmaster } = authorizationStore;
const { isImpersonating } = storeToRefs(authorizationStore);

// Refs
const isOpen = ref(false);

// Initials
const userInitials = computed(() => {
  const { formattedName } = user.value || {};

  if (formattedName) {
    const names = formattedName.split(" ").filter(Boolean);

    // Take at most the first two names for initials
    return names
      .slice(0, 2)
      .map((name) => name.charAt(0).toUpperCase())
      .join("");
  }

  return "";
});

const links = computed(() => {
  return [
    ...profileItems.value,
    ...(isImpersonating.value === true
      ? [
          {
            name: "ApiTesterImpersonating",
            meta: {
              title: "API Tester",
              icon: "fa-solid fa-code",
            },
          },
          {
            meta: {
              title: "Terug naar webmaster account",
              icon: toClassicIcon(webmasterIcon),
            },
            action: returnAsWebmaster,
          },
        ]
      : []),
    logoutMenuItem,
  ];
});

onMounted(async () => {
  await loadCurrentUser();
});
</script>
